import React, { useMemo } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import muiTheme, { DIALOG_RADIUS } from "../../../theme/mui/styles";

export default function VendorConfirmationModal({
  isOpen,
  onClose,
  title,
  message,
  confirmLabel = "Confirm",
  confirmColor = "primary",
  loading,
  onConfirm,
}) {
  const theme = muiTheme;

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={Boolean(isOpen)}
        onClose={loading ? undefined : onClose}
        fullWidth
        maxWidth="xs"
        PaperProps={{ sx: { borderRadius: DIALOG_RADIUS, mt: 10 } }}
      >
        <DialogTitle>{title || "Confirm Action"}</DialogTitle>
        <DialogContent>
          <Typography>{message}</Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2, pt: 1 }}>
          <Button
            onClick={onClose}
            disabled={loading}
            sx={{ textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            color={confirmColor}
            variant="contained"
            onClick={onConfirm}
            disabled={loading}
            sx={{ textTransform: "none" }}
          >
            {loading ? "Processing..." : confirmLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
